export default "__VITE_ASSET__BVlTxmFe__"